<template lang="pug">
    div
        div.order-step
            div.title
                div.text 已耗时：{{ detailData.timeConsuming | fieldVaild }}
                div.service-tips {{ `凯励程APP服务记录${detailData.visibleServiceRecord ? '' : '不'}可见` }}
            div.order-step-content
                div(style="overflow: hidden")
                    template(v-for="(flow) in flowList")
                        div.step-item(v-if="(hasConstruction && flow.name === '车辆施工') || flow.name === '车辆检测' || (flow.name === '车辆交付' && hasDeliver)")
                            div.step-main-title
                                span.line-shadow(v-if="flow.name === '车辆检测'")
                                span.grey-circle
                                span {{ flow.name }}
                            template(v-for="(item) in flow.dataList")
                                div.step-sub-info(v-if="hasItem(item)")
                                    div.step-line
                                    div.step-icon(v-if="activeItem(item.key)")
                                        svg-icon.icon(:icon-class="svgMap['PASS']")
                                    div.grey-point(v-if="disableItem(item.key)")
                                    span.sub-title(:class="{'disabled': disableItem(item.key) }") {{ item.name }}
                                        span.jump-tag(v-if="ignoreItem(item.key)") 跳过
                                        span.complete-data(
                                            v-if="ignoreItem(item.key) && ['CHECKING', 'UNDER_CONSTRUCTION', 'IN_DELIVERY'].includes(detailData.orderStatus) && isStore"
                                            :class="{'disabled': !hasResolveAuth}"
                                            @click="completeData(item)") 去完善
                                            svg-icon(
                                                :icon-class="hasResolveAuth ? 'arrow-right' : 'arrow-right-grey'"
                                                :className="'arrow-right'"
                                            )
                                    div.info-operator(v-if="commitItem(item.key) || ignoreItem(item.key)") 提交人：
                                        span {{ detailData[item.key].operatorName }} {{ detailData[item.key].operatorPhone }} {{ detailData[item.key].operateTime | dateFormat }}
                                    div(v-if="commitItem(item.key) || (item.key === 'autox3MaintenanceCheck' && detailData[item.key].content && detailData[item.key].content.checkOrders)")
                                        // 车辆预检独有字段
                                        template(v-if="item.key === 'preCheck'")
                                            div.info-item 车身概况：{{ vehicleConditionStr }}
                                        // 智能保养车辆预检独有字段
                                        template(v-if="item.key === 'autox3PreCheck'")
                                            div.check-order-list
                                                div.header(v-if="detailData[item.key].content.status === 'COMPLETED'")
                                                    .name 预检报告
                                                    div(@click="viewReport(detailData[item.key].content, '预检报告')").link 查看报告
                                                        svg-icon(
                                                            icon-class="arrow-right"
                                                            :className="'arrow-right'"
                                                        )
                                                div.info-submitter(v-if="detailData[item.key].content.status === 'COMPLETED'") 提交人：
                                                    span {{ detailData[item.key].content.submitterName }} {{ detailData[item.key].content.submitterPhone }} {{ detailData[item.key].content.submitTime | dateFormat }}
                                        // 智能保养检测独有字段
                                        template(v-if="item.key === 'autox3MaintenanceCheck'")
                                            div.check-order-list(v-for="(val) in detailData[item.key].content.checkOrders" :key="val.checkOrderId")
                                                div.header(v-if="val.checkOrderStatus === 'COMPLETED'")
                                                    .name {{ val.checkItemName }}
                                                    div(@click="viewReport(val, '检测报告')").link 查看报告
                                                        svg-icon(
                                                            icon-class="arrow-right"
                                                            :className="'arrow-right'"
                                                        )
                                                div.info-submitter(v-if="val.checkOrderStatus === 'COMPLETED'") 提交人：
                                                    span {{ val.submitterName }} {{ val.submitterPhone }} {{ val.submitTime | dateFormat }}
                                                div.info-submitter(v-if="val.checkOrderStatus === 'COMPLETED' && (val.assigneeName || val.assigneePhone)") 施工人员：
                                                    span {{ val.assigneeName }} {{ val.assigneePhone }}
                                        // 智能保养车辆保养独有字段
                                        template(v-if="item.key === 'autox3Maintenance'")
                                            div.check-order-list(v-for="(val) in detailData[item.key].content.constructionOrders" :key="val.constructionOrderId")
                                                div.header(v-if="val.status === 'COMPLETED'")
                                                    .name {{ val.name }}
                                                    div(@click="viewReport(val, '施工报告')").link 查看报告
                                                        svg-icon(
                                                            icon-class="arrow-right"
                                                            :className="'arrow-right'"
                                                        )
                                                div.info-submitter(v-if="val.status === 'COMPLETED'") 提交人：
                                                    span {{ val.submitterName }} {{ val.submitterPhone }} {{ val.submitTime | dateFormat }}
                                                div.info-submitter(v-if="val.status === 'COMPLETED' && (val.assigneeName || val.assigneePhone)") 施工人员：
                                                    span {{ val.assigneeName }} {{ val.assigneePhone }}
                                        // 保养检测独有字段(保养)
                                        template(v-if="commitItem(item.key) && (item.key === 'maintenanceCheck' || item.key === 'autox3MaintenanceCheck')")
                                            div.info-item
                                                span 报价金额(元)：
                                                span 工时费：{{ detailData[item.key].content.quotationPersonnelAmount | amountFormat }}
                                                span(style="margin: 0 10px; position: relative; top: -1px") |
                                                span 材料费：{{ detailData[item.key].content.quotationMaterialAmount | amountFormat }}
                                            div.info-item
                                                span 成本金额(元)：
                                                span 工时费：{{ detailData[item.key].content.overhaulPersonnelAmount | amountFormat }}
                                                span(style="margin: 0 10px; position: relative; top: -1px") |
                                                span 材料费：{{ detailData[item.key].content.overhaulMaterialAmount | amountFormat }}
                                            div.info-item 是否订购配件：{{ detailData[item.key].content.buyComponents ? '是' : '否' }}
                                            div.info-item 是否钣金施工：{{ detailData[item.key].content.sprayPaint ? '是' : '否' }}
                                            div.info-item 是否车辆喷漆：{{ detailData[item.key].content.vehiclePainting ? '是' : '否' }}
                                        // 配件处理独有字段
                                        template(v-if="item.key === 'component'")
                                            div.info-item 到货时间：{{ detailData[item.key].content.arrivalTime | dateFormat | fieldVaild }}
                                        // 车辆交付独有字段
                                        template(v-if="item.key === 'deliver'")
                                            div.info-item(v-if="checkData && checkData.content")
                                                span 成本金额(元)：
                                                span 总计：{{ checkData.content.overhaulAmount | amountFormat }}
                                                span(style="margin: 0 5px")
                                                span (工时费：{{ checkData.content.overhaulPersonnelAmount | amountFormat }}
                                                span(style="margin: 0 10px; position: relative; top: -2px") |
                                                span 材料费：{{ checkData.content.overhaulMaterialAmount | amountFormat }})
                                            div.info-item(v-if="!checkData || !checkData.content")
                                                span 成本金额(元)：
                                                span 总计：--
                                                span(style="margin: 0 5px")
                                                span (工时费：--
                                                span(style="margin: 0 10px; position: relative; top: -2px") |
                                                span 材料费：--)
                                            div.info-item(v-if="!isDetailAmount")
                                                span 结算金额(元)：
                                                span {{ detailData[item.key].content.paymentAmount | amountFormat }}
                                            div.info-item(v-if="isDetailAmount")
                                                span 应收合计(元)：
                                                span {{ detailAmount.originalAmount | amountFormat }}
                                            div.info-item(v-if="isDetailAmount")
                                                span 优惠合计(元)：
                                                span {{ detailAmount.discountAmount | amountFormat }}
                                            div.info-item(v-if="isDetailAmount")
                                                span 结算金额(元)：
                                                span {{ detailAmount.paymentAmount | amountFormat }}
                                            div.info-item 下次保养里程：{{ detailData[item.key].content.nextMaintenanceMileage | fieldVaild }}
                                                span(v-if="detailData[item.key].content.nextMaintenanceMileage") km
                                            div.info-item 下次保养时间：{{ detailData[item.key].content.nextMaintenanceTime | dateFormat('YYYY/MM/DD') | fieldVaild }}
                                            div.info-item 建议保养项目：{{ nextMaintenanceProjectStr }}
                                        // 图片公共区
                                        template(v-for="(picture) in item.imageList")
                                            div.info-item {{ picture.name }}：
                                                span(v-if="!pictureList[picture.value].length") --
                                            div.info-images
                                                div.images(v-if="pictureList[picture.value].length")
                                                    img(
                                                        v-for="(img, idx) in pictureList[picture.value]"
                                                        :key="idx"
                                                        style="width: 48px; height: 48px; margin-right: 10px; margin-bottom: 8px;"
                                                        :src="img"
                                                        @click="handleShowImage(img, pictureList[picture.value])"
                                                    )
                                        div.info-item(v-if="commitItem(item.key) && item.remarkName") 备注：{{ detailData[item.key].content[item.remarkName] | fieldVaild }}

        image-viewer(
            v-if="showViewer"
            :showViewer.sync="showViewer"
            :currentUrl="currentUrl"
            :urlList="urlList"
        )
        el-drawer.report-drawer(
            :title="reportTitle"
            :visible.sync="drawerShow"
            :direction="'rtl'"
            :wrapper-closable="false"
            :size="'430px'"
        )
            iframe(:src="reportSrc" frameborder="0").report-frame
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import oss from '@/utils/oss';
import { handleParameter } from '@/filters';
import ImageViewer from '@/components/ImageViewer.vue';

export default {
    name: 'OrderStep',
    props: {
        detailData: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    components: {
        ImageViewer,
    },
    computed: {
        ...mapState('user', [
            'userInfo',
        ]),
        ...mapGetters('user', [
            'getAuthority',
        ]),
        vehicleConditionStr() {
            let str = '--';
            if (this.detailData.preCheck && this.detailData.preCheck.content && this.detailData.preCheck.content.vehicleCondition) {
                str = this.detailData.preCheck.content.vehicleCondition.join('、');
            }
            return str;
        },
        nextMaintenanceProjectStr() {
            let str = '--';
            if (this.detailData.deliver && this.detailData.deliver.content && this.detailData.deliver.content.nextMaintenanceProject) {
                str = this.detailData.deliver.content.nextMaintenanceProject.join('、');
            }
            return str;
        },
        hasConstruction() {
            return ['UNDER_CONSTRUCTION'].includes(this.detailData.orderStatus) || this.detailData.component || this.detailData.maintenance || this.detailData.autox3Maintenance || this.detailData.sprayPaint || this.detailData.vehiclePainting;
        },
        hasDeliver() {
            return ['IN_DELIVERY'].includes(this.detailData.orderStatus) || this.detailData.deliver;
        },
        isAutoX3MaintenanceCheck() {
            return (this.detailData.upcomingList && this.detailData.upcomingList.includes('AUTOX3_MAINTENANCE_CHECK')) || this.detailData.autox3MaintenanceCheck;
        },
        isAutoX3Maintenance() {
            return (this.detailData.upcomingList && this.detailData.upcomingList.includes('AUTOX3_MAINTENANCE')) || this.detailData.autox3Maintenance;
        },
        checkData() {
            return this.isAutoX3MaintenanceCheck ? this.detailData.autox3MaintenanceCheck : this.detailData.maintenanceCheck;
        },
        maintenanceData() {
            return this.isAutoX3Maintenance ? this.detailData.autox3Maintenance : this.detailData.maintenance;
        },
        isDetailAmount() {
            const { deliver } = this.detailData;
            return deliver && deliver.content && deliver.content.paymentAmountDetail;
        },
        detailAmount() {
            return this.isDetailAmount ? this.detailData.deliver.content.paymentAmountDetail : {};
        },
        hasResolveAuth() {
            return this.getAuthority('MaintenanceWorkOrder', 'MaintenanceWorkOrderOperate');
        },
        isStore() {
            return this.userInfo.orgType === 'STORE';
        },
    },
    data() {
        return {
            svgMap: {
                PASS: 'collison-audit-pass',
            },
            showViewer: false,
            drawerShow: false,
            reportSrc: '',
            reportTitle: '',
            urlList: [],
            currentUrl: '',
            pictureList: {
                preCheckPicture: [],
                vehicleConditionPicture: [],
                damagePicture: [],
                disassemblePicture: [],
                arrivalPicture: [],
                repairPicture: [],
                sprayPaintPicture: [],
                vehiclePaintingPicture: [],
                deliverPicture: [],
                checkPicture: [],
                maintenancePicture: [],
            },
            flowList: [
                {
                    name: '车辆检测',
                    dataList: [],
                },
                {
                    name: '车辆施工',
                    dataList: [
                        {
                            key: 'component',
                            name: '配件处理',
                            imageList: [
                                { name: '到货凭证', value: 'arrivalPicture' },
                            ],
                            remarkName: 'arrivalRemark',
                        },
                    ],
                },
                {
                    name: '车辆交付',
                    dataList: [
                        {
                            key: 'deliver',
                            name: '车辆交付',
                            imageList: [
                                { name: '图片凭证', value: 'deliverPicture' },
                            ],
                        },
                    ],
                },
            ],
            picNames: [
                // 此处也有维修保养相关
                ['preCheck', 'preCheckPicture'],
                ['preCheck', 'vehicleConditionPicture'],
                ['component', 'arrivalPicture'],
                ['sprayPaint', 'sprayPaintPicture'],
                ['vehiclePainting', 'vehiclePaintingPicture'],
                ['deliver', 'deliverPicture'],
                ['maintenanceCheck', 'checkPicture'],
                ['maintenance', 'maintenancePicture'],
            ],
        };
    },
    watch: {
        detailData(val) {
            if (this.flowList[0].dataList.length === 0) {
                if (val.autox3PreCheck) {
                    this.flowList[0].dataList.push({
                        key: 'autox3PreCheck',
                        name: '车辆预检',
                    });
                } else {
                    this.flowList[0].dataList.push({
                        key: 'preCheck',
                        name: '车辆预检',
                        imageList: [
                            { name: '预检凭证', value: 'preCheckPicture' },
                            { name: '车身情况', value: 'vehicleConditionPicture' },
                        ],
                    });
                }
                if (val.autox3MaintenanceCheck) {
                    this.flowList[0].dataList.push({
                        key: 'autox3MaintenanceCheck',
                        name: '保养检测',
                        imageList: [],
                        remarkName: 'checkRemark',
                    });
                } else {
                    this.flowList[0].dataList.push({
                        key: 'maintenanceCheck',
                        name: '保养检测',
                        imageList: [
                            { name: '检测凭证', value: 'checkPicture' },
                        ],
                        remarkName: 'checkRemark',
                    });
                }
            }
            if (this.flowList[1].dataList.length === 1) {
                if (val.autox3Maintenance || (val.upcomingList && val.upcomingList.includes('AUTOX3_MAINTENANCE'))) {
                    this.flowList[1].dataList.push({
                        key: 'autox3Maintenance',
                        name: '车辆保养',
                    });
                } else {
                    const list = [
                        {
                            key: 'maintenance',
                            name: '车辆保养',
                            imageList: [
                                { name: '完工凭证', value: 'maintenancePicture' },
                            ],
                            remarkName: 'maintenanceRemark',
                        },

                        {
                            key: 'sprayPaint',
                            name: '钣金施工',
                            imageList: [
                                { name: '完工凭证', value: 'sprayPaintPicture' },
                            ],
                            remarkName: 'sprayPaintRemark',
                        },
                        {
                            key: 'vehiclePainting',
                            name: '车辆喷漆',
                            imageList: [
                                { name: '完工凭证', value: 'vehiclePaintingPicture' },
                            ],
                            remarkName: 'vehiclePaintingRemark',
                        },
                    ];
                    this.flowList[1].dataList = [...this.flowList[1].dataList, ...list];
                }
            }
            this.picNames.forEach((item) => {
                if (val[item[0]] && val[item[0]].content && val[item[0]].content[item[1]] && val[item[0]].content[item[1]].length) {
                    this.getFullPath(item[0], item[1]);
                }
            });
        },
    },
    methods: {
        activeItem(key) {
            if (key === 'deliver') return this.detailData[key];
            return this.detailData[key] && this.detailData[key].itemStatus !== 'STASH';
        },
        disableItem(key) {
            if (key === 'deliver') return !this.detailData[key];
            return !this.detailData[key] || this.detailData[key].itemStatus === 'STASH';
        },
        ignoreItem(key) {
            if (key === 'deliver') return false;
            return this.detailData[key] && this.detailData[key].itemStatus === 'IGNORE';
        },
        commitItem(key) {
            if (key === 'deliver') return (this.detailData[key] && this.detailData[key].content);
            return this.detailData[key] && this.detailData[key].itemStatus === 'COMMIT';
        },
        hasItem(item) {
            if (item.key === 'component') {
                return this.commitItem(this.isAutoX3MaintenanceCheck ? 'autox3MaintenanceCheck' : 'maintenanceCheck') && this.checkData && this.checkData.content && this.checkData.content.buyComponents;
            }
            if (item.key === 'sprayPaint') {
                return this.commitItem(this.isAutoX3MaintenanceCheck ? 'autox3MaintenanceCheck' : 'maintenanceCheck') && this.checkData && this.checkData.content && this.checkData.content.sprayPaint;
            }
            if (item.key === 'vehiclePainting') {
                return this.commitItem(this.isAutoX3MaintenanceCheck ? 'autox3MaintenanceCheck' : 'maintenanceCheck') && this.checkData && this.checkData.content && this.checkData.content.vehiclePainting;
            }
            return true;
        },
        getFullPath(type1, type2) {
            this.downLoadFile(this.detailData[type1].content[type2], type2);
        },
        downLoadFile(urls, type) {
            this.pictureList[type] = [];
            const promiseList = [];
            const resList = [];
            for (let i = 0, len = urls.length; i < len; i++) {
                promiseList.push(oss.downloadFile(urls[i], 'PRIVATE', 1000)
                    .then((res) => {
                        resList[i] = {
                            url: res,
                            name: urls[i],
                            hasUpload: true,
                        };
                    }));
            }
            Promise.all(promiseList).finally(() => {
                resList.forEach((val) => {
                    this.pictureList[type].push(val.url);
                });
                this.$forceUpdate();
            });
        },
        handleShowImage(url, urls) {
            this.currentUrl = url;
            this.urlList = urls;
            this.showViewer = true;
        },
        completeData(item) {
            if (!this.hasResolveAuth) return;
            this.$emit('completeData', item);
        },
        viewReport(item, title) {
            handleParameter({
                trackKey: 'workorderservice_techdetail_checkreport_click',
                attr: {
                    shop_id: this.userInfo.lastLoginOrgId,
                    account_type: this.userInfo.orgType,
                    xyt_id: this.userInfo.id,
                    workorder_id: this.detailData.id,
                    serviceitem_id: item.checkOrderId,
                },
            });
            this.reportSrc = item.reportUrl;
            this.reportTitle = title;
            this.drawerShow = true;
        },
    },
};
</script>

<style lang="scss" scoped>
    .order-step {
        margin-bottom: 10px;
        @include bg_color(color_base_white);
        &-content {
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
            padding: 20px;
            position: relative;
            overflow: hidden;
            .step-line {
                position: absolute;
                height: 1000px;
                top: -990px;
                left: -16px;
                border: 1px solid #EEEEEE;
                z-index: 1;
            }
            .step-item {
                padding-left: 24px;
                margin-bottom: 12px;
                .info-item {
                    line-height: 20px;
                    margin-bottom: 8px;
                    font-size: 14px;
                    color: #333333;
                    font-weight: 400;
                }
                .info-operator {
                    height: 18px;
                    line-height: 18px;
                    font-size: 12px;
                    color: #999999;
                    font-weight: 400;
                    margin-bottom: 8px;
                }
                .info-images {
                    display: flex;
                }
                .step-main-title {
                    position: relative;
                    height: 22px;
                    line-height: 22px;
                    font-size: 12px;
                    color: rgba(0,0,0,0.65);
                    margin-bottom: 12px;
                    .grey-circle {
                        position: absolute;
                        display: inline-block;
                        width: 8px;
                        height: 8px;
                        top: 7px;
                        left: -19px;
                        border-radius: 50%;
                        background: #FFFFFF;
                        border: 2px solid #BABABA;
                        z-index: 2;
                    }
                    .line-shadow {
                        position: absolute;
                        display: inline-block;
                        width: 6px;
                        height: 6px;
                        top: 0;
                        left: -18px;
                        background: #FFFFFF;
                        z-index: 3;
                    }
                }
                .step-sub-info {
                    position: relative;
                    line-height: 18px;
                    font-size: 14px;
                    color: #333333;
                    font-weight: bold;
                    margin-bottom: 12px;
                    .sub-title {
                        margin-bottom: 8px;
                        display: flex;
                        &.disabled {
                            color: rgba(0,0,0,0.45);
                        }
                        .jump-tag {
                            width: 40px;
                            height: 20px;
                            line-height: 18px;
                            text-align: center;
                            background: #F5F5F5;
                            border: 1px solid #EEEEEE;
                            border-radius: 2px;
                            font-size: 12px;
                            color: #999999;
                            margin-left: 8px;
                            font-weight: normal;
                        }
                        .complete-data {
                            color: #4877F4;
                            font-size: 14px;
                            margin-left: 16px;
                            cursor: pointer;
                            font-weight: normal;
                            &.disabled {
                                color: #a9a9a9;
                                cursor: not-allowed;
                            }
                        }
                    }
                    .step-icon {
                        width: 18px;
                        height: 18px;
                        position: absolute;
                        top: 0;
                        left: -24px;
                        z-index: 2;
                        .icon {
                            width: 18px;
                            height: 18px;
                        }
                    }
                    .grey-point {
                        display: inline-block;
                        width: 6px;
                        height: 6px;
                        position: absolute;
                        background: #D0D0D0;
                        border-radius: 50%;
                        top: 6px;
                        left: -18px;
                        z-index: 2;
                    }
                }
            }
        }
        .title {
            display: flex;
            margin-bottom: 1px;
            padding: 0 20px;
            align-items: center;
            border-bottom: 1px solid #EEEEEE;
            justify-content: space-between;
            @include bg_color(color_base_white);
            .text {
                line-height: 40px;
                @include font_weight(text_font_weight);
                @include font_color(color_base_gray9);
            }
            .service-tips {
                height: 20px;
                line-height: 18px;
                background: rgba(0,0,0,0.04);
                border: 1px solid rgba(0,0,0,0.15);
                border-radius: 2px;
                font-size: 12px;
                color: rgba(0,0,0,0.65);
                padding: 0 8px;
            }
        }
        .check-order-list {
            .header {
                display: flex;
                margin-bottom: 8px;
                font-weight: normal;
                // width: 290px;
                .name {
                    margin-right: 24px;
                }
                .link {
                    color: #4877F4;
                    font-size: 14px;
                    cursor: pointer;
                    min-width: 70px;
                }
            }
            .info-submitter {
                margin-bottom: 8px;
                font-weight: normal;
                height: 18px;
                line-height: 18px;
                font-size: 12px;
                color: #999999;
            }
        }
    }
    .report-frame {
        width: 100%;
        height: 100%;
    }
</style>
<style lang="scss">
.report-drawer{
    .el-drawer__header {
        margin-bottom: 12px;
        padding: 12px 20px 0;
    }
}
</style>
